<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/danju.png" class="jxyd-imgicon" />
				操作其它入库单
			</div>
			<button class="jxyd-button jxyd-primary" title="审核" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkbox-outline" size='18' />
				审核
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-print" size='18' />
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18' />
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>

				<table class="baseinfo-table">
					<tr>
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>
					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
							仓库
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" @on-change="depotChange" v-model="documentItem.depotId" filterable
								clearable>
								<Option v-for="item in depotList" :value="item.id" :key="item.id">
									{{ item.depotName }}
								</Option>
							</Select>
						</td>
					</tr>
					<tr>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						商品信息
					</div>
					<div class="layout-title-right">
						<SelectCommodityModal ref="selectCommodityModal"
							@getResult="data=>{this.commoditySelected = data;}" :selectedCommodity="commoditySelected"
							:type='"0"'></SelectCommodityModal>
						<SelectCommodityByCodeModal ref="selectCommodityByCodeModal"
							:commoditySelected="commoditySelected"
							@submitSelected='data=>{this.commoditySelected = data;}' @onInputVal='onInputVal'
							:type='"0"'>
						</SelectCommodityByCodeModal>
					</div>
				</div>
				<Table stripe :columns="commodityColumn" :data="documentItem.enterStoreDetailList"></Table>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0' />
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已审核</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
			<div id="hiprint-printTemplate" class="designer-canvas"></div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import SelectCommodityModal from '@/components/SelectCommodityModal'
	import DocumentFile from '@/components/DocumentFile'
	import SelectCommodityByCodeModal from '@/components/SelectCommodityByCodeModal'
	import printMixin from '@/mixins/printMixin' // 引入打印 mixin
	export default {
		name: 'enterstorelistfunc',
		mixins: [printMixin],
		components: {
			SelectCommodityModal,
			DocumentFile,
			SelectCommodityByCodeModal
		},
		computed: {
			commoditySelected: {
				get() {
					let data = [];
					this.documentItem.enterStoreDetailList.forEach(item => {
						let formatItems = item.format.split(',');
						let priceTypeData = {};
						let imgFiles = null;
						if (formatItems.length > 1) {
							let priceTypeGroup = item.commodity.commodityPriceTypeGroups.find(m => m
								.groupName == formatItems[0]);
							if (priceTypeGroup) {
								imgFiles = priceTypeGroup.imgFiles;
							}
							priceTypeData = priceTypeGroup.commodityPriceTypes.find(m => m.priceType ==
								formatItems[1]);
						}
						let existData = data.find(m => m.commodity.id == item.commodity.id);
						let isExist = true;
						if (existData) {
							for (let i = 0; i < existData.data.length; i++) {
								if (existData.data[i].unit != item.unit) {
									isExist = false;
									break;
								}
								if (existData.data[i].priceType == item.format) {
									isExist = false;
									break;
								}
							}
						}
						if (existData && isExist) {
							existData.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								sellByDate: item.sellByDate,
								unit: item.unit,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
						} else {

							let dataItem = {};
							dataItem.commodity = item.commodity;

							dataItem.data = [];
							dataItem.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								sellByDate: item.sellByDate,
								unit: item.unit,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
							data.push(dataItem);
						}
					});
					return data;

				},
				set(newValue) {
					//这的data就是B页面传递过来的数据
					this.documentItem.enterStoreDetailList = []
					newValue.forEach(item => {
						item.data.forEach(item2 => {
							this.documentItem.enterStoreDetailList.push({
								commodityId: item.commodity.id,
								name: item.commodity.name,
								unit: item2.unit,
								format: item2.priceType,
								sellByDate: item2.sellByDate,
								quantity: item2.quantity,
								depotId: this.documentItem.depotId ? this.documentItem
									.depotId : 0,
								depotName: this.documentItem.depotName ? this
									.documentItem.depotName : '',
								price: item2.intoPrice,
								note: '',
								creator: parseInt(localStorage.getItem("userId")),
								commodity: item.commodity
							})
						});
					});
				}
			}
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					depotId: '',
					depotName: '',
					enterStoreDetailList: [],
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					checkState: 1, //未审核
					fileList: []
				},
				depotList: [],
				commodityColumn: [{
						title: '操作',
						key: 'action',
						width: 80,
						align: 'center',
						fixed: 'left',
						render: (h, params) => {
							return [h('Icon', {
								style: {
									cursor: 'pointer'
								},
								props: {
									type: 'md-trash',
									size: 24
								},
								on: {
									click: (e) => {
										this.documentItem.enterStoreDetailList.splice(params.index,
											1);
									}
								}
							})]
						}
					},
					{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 300,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '计量单位',
						key: 'unit',
						width: 130,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (event) => {
											this.documentItem.enterStoreDetailList[params.index].unit =
												event;
										}
									},
								},
								params.row.commodity.extraUnits.map(function(type) {
									return h('Option', {
										props: {
											value: type.unit,
											key: type.unit
										}
									}, type.unit);
								})
							)];
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 200,
					},
					{
						title: '仓库',
						key: 'depotId',
						width: 130,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.depotId
									},
									style: {
										width: '100%'
									},
									on: {
										input: (event) => {
											this.documentItem.enterStoreDetailList[params.index]
												.depotId = event;
										}
									},
								},
								this.depotList.map(function(depot) {
									return h('Option', {
										props: {
											value: depot.id,
											key: depot.depotName
										}
									}, depot.depotName);
								})
							)];
						}
					},
					{
						title: '保质期',
						key: 'sellbyDate',
						width: 200,
						render: (h, params) => {
							return h('DatePicker', {
								attrs: {
									transfer: true,
									type: 'daterange',
									value: params.row.sellByDate,
									placeholder: '请选择',
									disabled: !this.documentItem.enterStoreDetailList[params.index]
										.commodity.enableBatch
								},
								on: {
									'on-change': (e) => {
										this.documentItem.enterStoreDetailList[params.index]
											.sellByDate = e;
									}
								}
							})
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 200,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.documentItem.enterStoreDetailList[params.index]
											.quantity = e;
									}
								}
							})]
						}
					},
					{
						title: '采购价格',
						key: 'price',
						width: 200,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIntoPrice(params.row));
						}
					},
					{
						title: '备注',
						key: 'note',
						width: 400,
					}
				],
				userList: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				}
			}
		},

		methods: {
			getCurrentIntoPrice(data) {
				let items = data.format.split(',');
				if (items.length <= 0) {
					return 0;
				}
				let priceTypeGroup = data.commodity
					.commodityPriceTypeGroups.find(m => m.groupName == items[0]);
				if (!priceTypeGroup || priceTypeGroup.commodityPriceTypes.length <= 0) {
					return 0;
				}
				let priceType = priceTypeGroup.commodityPriceTypes.find(m => m.priceType == items[1]);
				if (!priceType) {
					return 0;
				}
				let unitData = this.getUnitData(data, data.unit);
				if (!unitData) {
					return 0;
				}
				return formatNum(priceType.intoPrice / unitData.conversionRate);
			},
			getUnitData(detail, unitName) {
				if (detail.commodity.extraUnits) {
					let unit = detail.commodity.extraUnits.find(m => m.unit == unitName);
					if (unit) {
						return unit;
					}
				}
				return null;
			},
			emptyForm() {
				this.documentItem.id = 0;
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
				this.documentItem.enterStoreDetailList = [];
				this.documentItem.depotId = '';
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = '';
				this.documentItem.checkState = 1; //未审核
				this.documentItem.fileList = [];
				this.getNextCode();
			},
			initDepotData() {
				let self = this;
				request.get('/api/Depot/GetDepotList').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取仓库数据失败：" + response.errorMsg
						});
						return;
					}
					self.depotList = response.data;
				}).catch(function(error) {})
			},
			depotChange(val) {
				for (let i = 0; i < this.documentItem.enterStoreDetailList.length; i++) {
					this.documentItem.enterStoreDetailList[i].depotId = this.documentItem.depotId;
				}
			},
			getCurrentIStock(index) {
				let commodityInventorys = this.documentItem.enterStoreDetailList[index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem.enterStoreDetailList[index]
						.format) {
						stock += commodityInventorys[i].stock;
					}
				}
				let extraUnits = this.documentItem.enterStoreDetailList[index].commodity.extraUnits;
				if (extraUnits) {
					extraUnits.forEach(item => {
						if (item.unit == this.documentItem.enterStoreDetailList[index].unit) {
							stock = item.conversionRate * stock;
						}
					});
				}
				return formatNum(stock);
			},
			submitValidate() {
				if (!this.documentItem.code) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "编号不可为空"
					});
					return false;
				}

				if (!this.documentItem.businessDate) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务日期"
					});
					return false;
				} else {}

				if (!this.documentItem.userId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务员"
					});
					return false;
				}

				if (!this.documentItem.depotId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择仓库"
					});
					return false;
				}

				if (this.documentItem.enterStoreDetailList.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择商品"
					});
					return false;
				}
				let detailArray = this.documentItem.enterStoreDetailList.filter(m => m.sellByDate.length < 2 && m
					.commodity.enableBatch == true);
				if (detailArray.length > 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "有商品未设置保质期"
					});
					return false
				}
				return true;
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/EnterStoreList/EditEnterStoreList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}
					//记录其它入库单操作
					var log = {
						FlowId: response.data,
						Title: '其它入库单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此其它入库单' : '创建了此其它入库单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					//清空form规则检查
					self.emptyForm();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
				}).catch(function(error) {})
			},
			onInputVal(val) {
				this.$refs.selectCommodityModal.searchItems.name = val;
				this.$refs.selectCommodityModal.openSelectCommodityModal();
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				let path = '';
				if (self.documentItem.id) {
					path = '/api/EnterStoreList/EditEnterStoreList';
				} else {
					path = '/api/EnterStoreList/AddEnterStoreList';
				}
				request.post(path, self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录其它入库单操作
					var log = {
						FlowId: self.documentItem.id ? response.data : response.data.id,
						Title: '其它入库单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此其它入库单' : '创建了此其它入库单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					if (!self.documentItem.id) {
						self.documentItem = response.data;
					} else {
						self.documentItem.id = response.data;
					}
					self.checkEnterStoreList(self.documentItem, '其它入库单审核后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			getNextCode() {
				let self = this;
				request.get('/api/EnterStoreList/GetNextCode', {
					params: {
						prefix: 'RKD'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			rollback(ids) {
				if (ids.length < 1) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到审核流程？',
					onOk() {
						request.post('/api/EnterStoreList/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "其它入库单回滚失败：" + response.errorMsg
								});
								return;
							}

							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: ids[i],
									Title: '其它入库单日志',
									OperationContent: '回滚了此其它入库单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getEnterStoreList(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			checkEnterStoreList(data, func) {
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/EnterStoreList/CheckEnterStoreList', [{
							id: data.id,
							state: 2
						}]).then(function(response) {

							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							var log = [];
							log.push({
								FlowId: data.id,
								Title: '其它入库单日志',
								OperationContent: '审核了此其它入库单',
								Operator: parseInt(localStorage.getItem("userId")),
								State: 1,
								Creator: parseInt(localStorage.getItem("userId"))
							});
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '审核成功!'
							});
							self.emptyForm();
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			initUserToSelect() { //初始化用户下拉框数据源
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['EnterStoreList.Add', 'EnterStoreList.Edit', 'EnterStoreList.Delete',
						'EnterStoreList.Audit', 'EnterStoreList.BatchAudit', 'EnterStoreList.Print',
						'EnterStoreList.Rollback', 'EnterStoreList.Export', 'EnterStoreList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'EnterStoreList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'EnterStoreList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'EnterStoreList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'EnterStoreList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'EnterStoreList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'EnterStoreList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'EnterStoreList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'EnterStoreList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'EnterStoreList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			printList() {
				// 准备打印数据（原 packPrintData 逻辑不变）
				const printData = this.formatPrintData([this.documentItem])
				// 使用 mixin 提供的打印方法
				this.printWithTemplate(printData, 'enterStoreList')
			},
			formatPrintData(rawData) {
				// rawData 已经是数组
				if (!Array.isArray(rawData)) {
					console.error('formatPrintData: rawData 不是数组', rawData);
					return [];
				}

				// 辅助函数：添加序号
				const addSerialNo = (arr) => arr.map((item, idx) => ({
					...item,
					serialNo: idx + 1
				}));

				// 辅助函数：安全获取数值
				const safeNumber = (value) => {
					const num = Number(value);
					return isNaN(num) ? 0 : num;
				};

				// 辅助函数：计算合计
				const calcTotals = (arr, fields) => {
					if (!Array.isArray(arr) || arr.length === 0) {
						const emptyTotals = {};
						fields.forEach(f => {
							emptyTotals[f] = 0;
						});
						return emptyTotals;
					}

					const totals = {};
					fields.forEach(f => {
						totals[f] = 0;
					});

					arr.forEach(item => {
						fields.forEach(f => {
							totals[f] += safeNumber(item[f]);
						});
					});

					return totals;
				};

				// 格式化日期
				const formatDate = (dateStr) => {
					if (!dateStr) return '';
					if (dateStr instanceof Date) {
						const year = dateStr.getFullYear();
						const month = String(dateStr.getMonth() + 1).padStart(2, '0');
						const day = String(dateStr.getDate()).padStart(2, '0');
						return `${year}-${month}-${day}`;
					}
					if (typeof dateStr === 'string') {
						// 处理 "2026-03-19 00:00:00" 或 "2026-03-19" 格式
						return dateStr.split(' ')[0];
					}
					return '';
				};

				// 获取商品单价（从商品信息中获取）
				const getCommodityPrice = (item) => {
					// 优先使用商品信息中的零售价
					if (item.commodity && item.commodity.retailPrice) {
						return safeNumber(item.commodity.retailPrice);
					}
					// 如果有价格字段
					if (item.price) {
						return safeNumber(item.price);
					}
					return 0;
				};

				// 格式化单条其它入库单记录
				const formatSingle = (record) => {
					if (!record) return {};

					// 格式化商品入库明细
					let commodityRaw = (record.enterStoreDetailList || []).map(item => ({
						name: item.name || '',
						format: item.format || '',
						unit: item.unit || '',
						quantity: safeNumber(item.quantity),
						price: getCommodityPrice(item),
						depotName: item.depotName || '', // 入库仓库
						batchCode: item.batchCode || '', // 批次码
						sellByDate: item.sellByDate && item.sellByDate[0] ? formatDate(item.sellByDate[
							0]) : '' // 保质期
					}));

					// 添加序号
					let commodityStockDetail = addSerialNo(commodityRaw);

					// 添加合计行（数量和金额合计）
					if (commodityRaw.length > 0) {
						const totals = calcTotals(commodityRaw, ['quantity']);
						// 计算总金额
						const totalAmount = commodityRaw.reduce((sum, item) => sum + (item.quantity * item.price), 0);
						commodityStockDetail.push({
							serialNo: '',
							name: '',
							format: '',
							unit: '合计',
							quantity: totals.quantity,
							price: '',
							depotName: '',
							batchCode: '',
							sellByDate: '',
							totalAmount: totalAmount,
							__style__: {
								fontWeight: 'bold',
								backgroundColor: '#f9f9f9'
							}
						});
					}

					// 返回格式化后的数据
					return {
						code: record.code || '',
						userName: record.userName || '',
						businessDate: formatDate(record.businessDate),
						note: record.note || '',
						commodityStockDetail: commodityStockDetail
					};
				};

				// 直接返回格式化后的数组
				return rawData.map(record => formatSingle(record));
			},
			getEnterStoreList(enterStoreListId) {
				let self = this;
				request.get('/api/EnterStoreList/GetEnterStoreList', {
					params: {
						id: enterStoreListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initEnterStoreList(response.data);
				}).catch(function(error) {})
			},
			initEnterStoreList(data) {
				this.documentItem = data;
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
			}
		},
		watch: {
			'$route.query.enterStoreListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getEnterStoreList(param);
					} else {
						this.emptyForm();
					}
				}
			}
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
			this.initDepotData();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}
</style>